import { FULL_DAY, TimeRange } from "../../core";
import { makeImmutable } from "../../core/makeImmutable";
/**
 * Represents multiple periods of time, in a day, for example: "from 6:00 to 10:00 and from 12:30 to 15:00"
 */
export class DailySchedule {
    constructor(timeRanges) {
        this.timeRanges = timeRanges;
        makeImmutable(this);
    }
    static fromRanges(timeRanges) {
        const sortedRanges = timeRanges.sort((a, b) => a.compare(b));
        // TODO Check if overlapping begin/end time ranges are handled correctly at corners
        const schedule = new DailySchedule(sortedRanges);
        if (schedule.duration > FULL_DAY) {
            throw new Error("Daily schedule cannot span more than one day");
        }
        return schedule;
    }
    static empty() {
        return new DailySchedule([]);
    }
    static full() {
        return new DailySchedule([TimeRange.FullDay]);
    }
    get duration() {
        return this.timeRanges.reduce((a, b) => a + b.duration, 0);
    }
    get isEmpty() {
        return this.duration === 0;
    }
    get isFull() {
        return this.duration === FULL_DAY;
    }
    includes(date) {
        return this.timeRanges.some((timeRange) => timeRange.includes(date));
    }
    intersection(other) {
        const result = [];
        let i = 0;
        let j = 0;
        while (i < this.timeRanges.length && j < other.timeRanges.length) {
            const thisRange = this.timeRanges[i];
            const otherRange = other.timeRanges[j];
            const intersection = thisRange.intersection(otherRange);
            if (!intersection.isEmpty) {
                result.push(intersection);
            }
            if (thisRange.to.isBefore(otherRange.to)) {
                i++;
            }
            else {
                j++;
            }
        }
        return new DailySchedule(result);
    }
}
